var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-between pl-3 border-right-dark"},[_c('span',{staticClass:"font-weight-medium mb-0"},[_vm._v("Delete: ")]),_c('img',{staticClass:"align-self-center ml-2 cursor-pointer",attrs:{"src":require("@/assets/images/delbtn.svg"),"alt":""},on:{"click":_vm.deleteSelectedItem}})])
}
var staticRenderFns = []

export { render, staticRenderFns }